import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { DropTargetMonitor } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import { useDrop } from 'react-dnd';

export const MAX_FILE_SIZE = 300;

export interface TargetBoxProps {
  onDrop: (item: { files: any[] }) => void;
  title: string;
  isLoading?: boolean;
}

const TargetBox: FC<TargetBoxProps> = (props) => {
  const { onDrop, title, isLoading } = props;
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item: { files: any[] }) {
        if (onDrop) onDrop(item);
      },
      canDrop(item: any) {
        if (isLoading) return false;
        return ['text/csv'].includes(item?.files[0]?.type);
      },
      collect: (monitor: DropTargetMonitor) => {
        return { isOver: monitor.isOver(), canDrop: monitor.canDrop() };
      },
    }),
    [props]
  );

  const handleClick = (e) => {
    const files = Array.from(e.target?.files);
    onDrop({ files });
  };

  const isActive = !isLoading && isOver;

  return (
    <Box
      ref={drop}
      alignItems="center"
      bgcolor="#EFF1F5"
      border="1px dashed"
      borderColor={isActive ? 'accent.100' : 'grey.30'}
      borderRadius="4px"
      display="flex"
      height="234px"
      justifyContent="center"
      px={6}
      textAlign="center"
    >
      <Box>
        <Typography component="p" variant="h5" color="grey.100">
          {title}
        </Typography>
        <Typography component="p" variant="p2" color="grey.100" mt={4}>
          Перетащите файлы сюда или {/*@ts-ignore*/}
          <Typography
            component="label"
            for="inputFile"
            variant="p2"
            color="accent.100"
            sx={{ cursor: 'pointer' }}
            mt={4}
          >
            выберите на компьютере
          </Typography>
        </Typography>
        <Typography component="p" variant="p3" color="grey.60" mt={2}>
          Максимальный размер файла: {MAX_FILE_SIZE} МБ
        </Typography>
      </Box>
      <Box
        disabled={isLoading}
        onChange={handleClick}
        accept=".csv"
        component="input"
        type="file"
        id="inputFile"
        multiple={true}
        sx={{ display: 'none' }}
      />
    </Box>
  );
};

export default TargetBox;
